"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _reactRequiredIf = _interopRequireDefault(require("react-required-if"));

var _DescriptionMessages = _interopRequireDefault(require("../DescriptionMessages"));

var _InputFieldButton = _interopRequireDefault(require("../InputFieldButton"));

var _InputLabel = _interopRequireDefault(require("../InputLabel"));

var _composeRefs = _interopRequireDefault(require("../../../utils/composeRefs"));

var _createUniqueElementIds = require("../../../utils/createUniqueElementIds/createUniqueElementIds");

var _autoFormatter = _interopRequireDefault(require("../../../utils/autoFormatter"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr && (typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]); if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var InputField = function InputField(_ref) {
  var autoCapitalize = _ref.autoCapitalize,
      autoComplete = _ref.autoComplete,
      autoCorrect = _ref.autoCorrect,
      autoFormat = _ref.autoFormat,
      buttonAriaLabel = _ref.buttonAriaLabel,
      buttonOnClick = _ref.buttonOnClick,
      buttonText = _ref.buttonText,
      classes = _ref.classes,
      dataTestId = _ref.dataTestId,
      description = _ref.description,
      descriptionId = _ref.descriptionId,
      errorMessages = _ref.errorMessages,
      formControlId = _ref.formControlId,
      handleOnChange = _ref.handleOnChange,
      handleOnKeyPress = _ref.handleOnKeyPress,
      hidePasswordButtonAriaLabel = _ref.hidePasswordButtonAriaLabel,
      hidePasswordButtonText = _ref.hidePasswordButtonText,
      initialValue = _ref.initialValue,
      inputFieldButtonRef = _ref.inputFieldButtonRef,
      inputFieldButtonTestId = _ref.inputFieldButtonTestId,
      inputId = _ref.inputId,
      inputMode = _ref.inputMode,
      inputRef = _ref.inputRef,
      isDescriptionHtml = _ref.isDescriptionHtml,
      isDisabled = _ref.isDisabled,
      isRequired = _ref.isRequired,
      isValid = _ref.isValid,
      label = _ref.label,
      labelId = _ref.labelId,
      maxLength = _ref.maxLength,
      minLength = _ref.minLength,
      pattern = _ref.pattern,
      placeholder = _ref.placeholder,
      showInputFieldButton = _ref.showInputFieldButton,
      showPasswordButtonAriaLabel = _ref.showPasswordButtonAriaLabel,
      showPasswordButtonText = _ref.showPasswordButtonText,
      size = _ref.size,
      type = _ref.type;
  var inputFieldButtonWrapperRef = (0, _react.useRef)(null);
  var altInputRef = (0, _react.useRef)(null);

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      passwordIsVisible = _useState2[0],
      setPasswordIsVisible = _useState2[1];

  var _useState3 = (0, _react.useState)(initialValue),
      _useState4 = _slicedToArray(_useState3, 2),
      value = _useState4[0],
      setValue = _useState4[1];

  var _useState5 = (0, _react.useState)(84),
      _useState6 = _slicedToArray(_useState5, 2),
      inputButtonWrapperWidth = _useState6[0],
      setInputButtonWrapperWidth = _useState6[1];

  var _useState7 = (0, _react.useState)((0, _createUniqueElementIds.createUniqueElementIds)('label')),
      _useState8 = _slicedToArray(_useState7, 1),
      labelUniqueId = _useState8[0];

  var _useState9 = (0, _react.useState)((0, _createUniqueElementIds.createUniqueElementIds)('input')),
      _useState10 = _slicedToArray(_useState9, 1),
      inputUniqueId = _useState10[0];

  var _useState11 = (0, _react.useState)((0, _createUniqueElementIds.createUniqueElementIds)('description')),
      _useState12 = _slicedToArray(_useState11, 1),
      descriptionUniqueId = _useState12[0];

  var handleSetValue = function handleSetValue(event) {
    return setValue(event.target.value);
  };

  var autoFormatValue = {
    card: (0, _autoFormatter.default)(value).card,
    ssn: (0, _autoFormatter.default)(value).ssn,
    phone: (0, _autoFormatter.default)(value).phone
  };

  var handleFormattingOnBlur = function handleFormattingOnBlur() {
    return setValue(autoFormatValue[autoFormat]);
  };

  var isPasswordInput = type === 'password';
  var formControlStyles = (0, _classnames.default)('form-control__container', {
    'form-control__container--error': !isValid
  }, classes);
  var inputFieldStyles = (0, _classnames.default)('form-control__input', {
    'form-control__input--error': !isValid,
    'form-control__input--small': size === 'small'
  });

  var inputElement = /*#__PURE__*/_react.default.createElement("input", {
    id: inputId || inputUniqueId,
    name: inputId || inputUniqueId,
    type: passwordIsVisible ? 'text' : type,
    value: autoFormatValue[autoFormat] || value,
    onBlur: autoFormat && handleFormattingOnBlur,
    onChange: function onChange(event) {
      handleSetValue(event);

      if (handleOnChange) {
        handleOnChange(event);
      }
    },
    onKeyPress: handleOnKeyPress,
    inputMode: inputMode,
    autoComplete: autoComplete,
    autoCorrect: autoCorrect,
    autoCapitalize: autoCapitalize,
    required: isPasswordInput || isRequired || null,
    disabled: isDisabled || null,
    "aria-disabled": isDisabled || null,
    "aria-required": isPasswordInput || isRequired || null,
    "aria-invalid": !isValid || null,
    "aria-describedby": (description || errorMessages && !isValid) && (descriptionId || descriptionUniqueId) || null,
    placeholder: placeholder,
    minLength: minLength,
    maxLength: maxLength,
    className: inputFieldStyles,
    pattern: pattern,
    ref: (0, _composeRefs.default)(inputRef, altInputRef) || null,
    style: (isPasswordInput || showInputFieldButton) && {
      paddingRight: "".concat(inputButtonWrapperWidth, "px")
    } || null,
    "data-testid": "inputField-input"
  });

  (0, _react.useEffect)(function () {
    setInputButtonWrapperWidth(Math.ceil(inputFieldButtonWrapperRef.current && inputFieldButtonWrapperRef.current.getBoundingClientRect().width));
  }, [passwordIsVisible]);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: formControlStyles,
    id: formControlId,
    "data-testid": dataTestId
  }, /*#__PURE__*/_react.default.createElement(_InputLabel.default, {
    inputId: inputId,
    inputUniqueId: inputUniqueId,
    isDisabled: isDisabled,
    isValid: isValid,
    label: label,
    labelId: labelId,
    labelUniqueId: labelUniqueId,
    type: type
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "form-control__input-wrapper"
  }, inputElement, (showInputFieldButton || isPasswordInput) && !isDisabled && /*#__PURE__*/_react.default.createElement(_InputFieldButton.default, {
    altInputRef: altInputRef,
    buttonAriaLabel: buttonAriaLabel,
    buttonOnClick: buttonOnClick,
    buttonText: buttonText,
    hidePasswordButtonAriaLabel: hidePasswordButtonAriaLabel,
    hidePasswordButtonText: hidePasswordButtonText,
    inputFieldButtonRef: inputFieldButtonRef,
    inputFieldButtonTestId: "".concat(inputFieldButtonTestId, "-").concat(inputId || inputUniqueId),
    isPassword: isPasswordInput,
    inputFieldButtonWrapperRef: inputFieldButtonWrapperRef,
    showPassword: passwordIsVisible,
    showPasswordButtonAriaLabel: showPasswordButtonAriaLabel,
    showPasswordButtonText: showPasswordButtonText,
    togglePasswordVisibility: setPasswordIsVisible
  })), (description || errorMessages.length > 0 && !isValid) && /*#__PURE__*/_react.default.createElement(_DescriptionMessages.default, {
    description: description,
    descriptionId: descriptionId,
    descriptionUniqueId: descriptionUniqueId,
    errorMessages: errorMessages,
    isDescriptionHtml: isDescriptionHtml,
    isDisabled: isDisabled,
    isValid: isValid
  }));
}; // needed for prop type checking refs in server side rendered apps


var Element = typeof Element === 'undefined' ? function () {} : Element; // eslint-disable-line

InputField.propTypes = {
  /**
   Optional. Controls how text input is automatically capitalized via virtual keyboards and voice input.
   */
  autoCapitalize: _propTypes.default.oneOf(['on', 'off', 'none', 'sentences', 'words', 'characters']),

  /**
   Optional. Allows user agent to provide assistance in filling out form field values by hinting or suggesting values to the user. Also helps the browser know what type of info to expect. For a password input, this should be set to either "current-password" or "new-password".
   */
  autoComplete: (0, _reactRequiredIf.default)(_propTypes.default.oneOf(['off', 'on', 'name', 'honorific-prefix', 'given-name', 'additional-name', 'family-name', 'honorific-suffix', 'nickname', 'email', 'username', 'new-password', 'current-password', 'one-time-code', 'organization-title', 'organization', 'street-address', 'address-line1', 'address-line2', 'address-line3', 'address-level4', 'address-level3', 'address-level4', 'address-level1', 'country', 'country-name', 'postal-code', 'cc-name', 'cc-given-name', 'cc-additional-name', 'cc-family-name', 'cc-number', 'cc-exp', 'cc-exp-month', 'cc-exp-year', 'cc-csc', 'cc-type', 'transaction-currency', 'transaction-amount', 'language', 'bday', 'bday-day', 'bday-month', 'bday-year', 'tel', 'tel-extension', 'impp', 'url', 'photo']), function (props) {
    return props.type === 'password' && props.autoFormat === null;
  }),

  /**
   Optional. A Safari extension that indicates whether or not to activate automatic correction while the user is editing the field.
   */
  autoCorrect: _propTypes.default.oneOf(['on', 'off']),

  /**
   Optional. Declares which type of auto-formatting to add to the input. autoFormat options: 'card', 'phone', 'ssn'.
   */
  autoFormat: _propTypes.default.oneOf(['card', 'ssn', 'phone']),

  /**
   Optional. aria-label for the form control CTA. Defaults to null.
   */
  buttonAriaLabel: _propTypes.default.string,

  /**
   Optional. Function passed to form control CTA. Defaults to null.
   */
  buttonOnClick: _propTypes.default.func,

  /**
   Optional. Text for the form control CTA. Defaults to null.
   */
  buttonText: _propTypes.default.string,

  /**
   Optional. Custom formControl container classes.
   */
  classes: _propTypes.default.string,

  /**
   Optional, but recommended. Gives a unique identifier to the element which is useful for testing scenarios.
   */
  dataTestId: _propTypes.default.string,

  /**
   Optional. Custom description of input group. Can be a string or a React component (object).
   */
  description: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.shape({})]),

  /**
   Optional. Custom id for description of input group.
   */
  descriptionId: _propTypes.default.string,

  /**
   Optional. Array of error message strings.
   */
  errorMessages: _propTypes.default.arrayOf(_propTypes.default.string),

  /**
   Optional. Custom id for formControl container.
   */
  formControlId: _propTypes.default.string,

  /**
   Optional. handleOnChange function.
   */
  handleOnChange: _propTypes.default.func,

  /**
   Optional. handleOnKeyPress function.
   */
  handleOnKeyPress: _propTypes.default.func,

  /**
   Optional. Text for the password input show/hide toggle CTA. Defaults to 'hide password'.
   */
  hidePasswordButtonAriaLabel: _propTypes.default.string,

  /**
   Optional. Text for the password input show/hide toggle CTA. Defaults to 'hide'.
   */
  hidePasswordButtonText: _propTypes.default.string,

  /**
   Optional. Initial value of the input. Defaults to ''.
   */
  initialValue: _propTypes.default.string,

  /**
   Optional. ref to be passed to the input label button element. Defaults to null.
   */
  inputFieldButtonRef: _propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.shape({
    current: _propTypes.default.instanceOf(Element)
  })]),

  /**
   Optional. data-testId for the input label button. Defaults to 'input-field-input-label-button'.
   */
  inputFieldButtonTestId: _propTypes.default.string,

  /**
   Optional. Custom id for \<input>.
   */
  inputId: _propTypes.default.string,

  /**
   Optional. inputMode hints at the type of data that might be entered by the user while editing the element or its contents .
   */
  inputMode: _propTypes.default.oneOf(['none', 'text', 'decimal', 'numeric', 'tel', 'search', 'email', 'url']),

  /**
   Optional. ref to be passed down to root element.
   */
  inputRef: _propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.shape({
    current: _propTypes.default.instanceOf(Element)
  })]),

  /**
   Optional. Used to pass HTML in the description prop. Defaults false.
   */
  isDescriptionHtml: _propTypes.default.bool,

  /**
   Optional. Defaults false.
   */
  isDisabled: _propTypes.default.bool,

  /**
   Optional. Defaults false. Defaults true for password.
   */
  isRequired: _propTypes.default.bool,

  /**
   Optional. Defaults true.
   */
  isValid: _propTypes.default.bool,

  /**
   Required. Label.
   */
  label: _propTypes.default.string.isRequired,

  /**
   Optional. Custom id for \<label>.
   */
  labelId: _propTypes.default.string,

  /**
   Optional. Set maxLength of an input.
   */
  maxLength: _propTypes.default.number,

  /**
   Optional. Set minLength of an input.
   */
  minLength: _propTypes.default.number,

  /**
   Optional. RegEx string used for HTML5 validation on submit. Defaults to null.
   */
  pattern: _propTypes.default.string,

  /**
   Optional. Custom placeholder for input.
   */
  placeholder: _propTypes.default.string,

  /**
   Optional. Passed if the CTA to the right of the input should be shown. Defaults to false.
   */
  showInputFieldButton: _propTypes.default.bool,

  /**
   Optional. Text for the password input show/hide toggle CTA. Defaults to 'show password'.
   */
  showPasswordButtonAriaLabel: _propTypes.default.string,

  /**
    Optional. Text for the password input show/hide toggle CTA. Defaults to 'show'.
    */
  showPasswordButtonText: _propTypes.default.string,

  /**
    Optional. Controls the size of the box and label. Options: 'large', 'small'. Defaults to 'large'.
    */
  size: _propTypes.default.oneOf(['large', 'small']),

  /**
   Required. Input type options: 'email', 'password', 'search', 'tel', 'text', 'url'.
   */
  type: _propTypes.default.oneOf(['email', 'password', 'search', 'tel', 'text', 'url']).isRequired
};
InputField.defaultProps = {
  autoCapitalize: null,
  autoComplete: null,
  autoCorrect: 'off',
  autoFormat: null,
  buttonAriaLabel: null,
  buttonOnClick: null,
  buttonText: null,
  classes: '',
  dataTestId: null,
  description: '',
  descriptionId: '',
  errorMessages: [],
  formControlId: null,
  handleOnChange: null,
  handleOnKeyPress: function handleOnKeyPress() {},
  hidePasswordButtonAriaLabel: 'Hide password',
  hidePasswordButtonText: 'Hide',
  initialValue: '',
  inputFieldButtonRef: null,
  inputFieldButtonTestId: 'input-field-input-label-button',
  inputId: '',
  inputMode: 'text',
  inputRef: null,
  isDescriptionHtml: false,
  isDisabled: false,
  isRequired: false,
  isValid: true,
  labelId: '',
  maxLength: null,
  minLength: null,
  pattern: null,
  placeholder: null,
  showInputFieldButton: false,
  showPasswordButtonAriaLabel: 'Show password',
  showPasswordButtonText: 'Show',
  size: 'large'
};
var _default = InputField;
exports.default = _default;